import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
const valueItems = [{
  label: 'Guía principal — Rutina de Autocuidado para Pies Sensibles',
  value: '$14.00',
  isBonus: false
}, {
  label: 'Bono #1 — Checklist Maestro de Autocuidado Diario',
  value: '$27.00',
  isBonus: true
}, {
  label: 'Bono #2 — Guía Rápida de Calzado Cómodo',
  value: '$19.00',
  isBonus: true
}, {
  label: 'Bono #3 — Plan de 7 Días para Crear tu Rutina',
  value: '$17.00',
  isBonus: true
}];
export function EmotionalClose() {
  return <section id="comprar" className="py-24 bg-white relative overflow-hidden" data-id="element-75">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-cream rounded-full blur-3xl -z-10 opacity-50" data-id="element-76" />

      <div className="max-w-3xl mx-auto px-6" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-78">
          <h2 className="text-3xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-79">
            Tu bienestar también vive en los pequeños detalles.
          </h2>

          <div className="space-y-6 text-lg text-charcoal-light leading-relaxed" data-id="element-80">
            <p data-id="element-81">
              A veces, dedicar unos minutos al día a observar, limpiar, secar y
              elegir mejor lo que usas puede ayudarte a sentir más calma, más
              orden y más conexión contigo.
            </p>
            <p data-id="element-82">
              Esta guía no busca complicarte. Busca acompañarte con una rutina
              simple, amable y fácil de sostener.
            </p>
          </div>
        </motion.div>

        {/* Value Table */}
        <motion.div id="precio" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-cream border border-bronze/20 rounded-sm overflow-hidden shadow-lg shadow-bronze/5 mb-10" data-id="element-83">
          <div className="bg-sage text-white py-3 px-4 text-center" data-id="element-84">
            <h3 className="font-serif text-base md:text-lg" data-id="element-85">
              Lo que recibes hoy
            </h3>
          </div>

          <div className="divide-y divide-bronze/10" data-id="element-86">
            {valueItems.map((item, index) => <div key={index} className="flex items-center justify-between px-4 py-3 gap-3" data-id="element-87">
                <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-88">
                  {item.isBonus ? <GiftIcon className="w-5 h-5 text-bronze shrink-0" data-id="element-89" /> : <CheckCircle2Icon className="w-5 h-5 text-bronze shrink-0" data-id="element-90" />}
                  <span className="text-charcoal text-sm md:text-base" data-id="element-91">
                    {item.label}
                  </span>
                </div>
                <div className="shrink-0 text-right" data-id="element-92">
                  {item.isBonus ? <div className="flex items-center gap-2" data-id="element-93">
                      <span className="text-charcoal-light line-through text-sm" data-id="element-94">
                        {item.value}
                      </span>
                      <span className="text-bronze-dark font-bold text-sm" data-id="element-95">
                        GRATIS
                      </span>
                    </div> : <span className="text-charcoal font-medium" data-id="element-96">
                      {item.value}
                    </span>}
                </div>
              </div>)}

            {/* Leer más link below bonus rows */}
            <div className="py-2 text-center border-t border-bronze/10" data-id="element-97">
              <button onClick={() => {
              const el = document.querySelector('#bonos');
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="inline-flex items-center gap-2 text-bronze-dark font-semibold hover:text-bronze transition-colors text-sm underline underline-offset-4" data-id="element-98">
                Leer más sobre los bonos
              </button>
            </div>
          </div>

          {/* Total Row */}
          <div id="precio" className="bg-cream-dark border-t-2 border-bronze/30" data-id="element-99">
            <div className="flex items-center justify-between px-4 py-2" data-id="element-100">
              <span className="font-serif text-base text-charcoal font-semibold" data-id="element-101">
                VALOR TOTAL REAL
              </span>
              <span className="text-charcoal-light line-through text-base" data-id="element-102">
                $77.00
              </span>
            </div>
            <div className="flex items-center justify-between px-4 pb-3" data-id="element-103">
              <span className="font-serif text-lg text-bronze-dark font-bold" data-id="element-104">
                🔥 Tu inversión hoy
              </span>
              <span className="text-2xl font-serif font-bold text-bronze-dark" data-id="element-105">
                Solo $14.00
              </span>
            </div>
          </div>
        </motion.div>

        {/* Closing Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mb-10" data-id="element-106">
          <p className="text-lg text-charcoal-light leading-relaxed mb-3" data-id="element-107">
            Todo esto — la guía completa más los 3 bonos — por solo{' '}
            <strong className="text-charcoal" data-id="element-108">$14.00</strong>.
          </p>
          <p className="text-charcoal-light leading-relaxed mb-1" data-id="element-109">
            No porque valga menos.
          </p>
          <p className="text-charcoal-light leading-relaxed mb-4" data-id="element-110">
            Sino porque queremos que empieces hoy. Sin barreras. Sin excusas.
            Sin esperar.
          </p>
          <p className="text-lg text-charcoal leading-relaxed font-medium" data-id="element-111">
            Por menos de lo que cuesta un café, tienes una rutina completa de
            autocuidado — más tres recursos adicionales — listos para descargar
            ahora mismo.
          </p>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="max-w-2xl mx-auto mb-6 bg-cream border border-bronze/30 px-6 py-4 text-center rounded-sm" data-id="element-112">
          <p className="text-charcoal font-medium leading-relaxed" data-id="element-113">
            <span className="text-bronze-dark font-bold" data-id="element-114">
              ✅ Garantía de 30 días
            </span>{' '}
            — Si no estás satisfecha te devuelvo cada centavo. Sin preguntas.
            Sin complicaciones.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex justify-center" data-id="element-115">
          <Button href="https://info-marketingdigital.com/cart/53014866657596:1" className="px-8 py-5 text-base md:text-lg" data-id="element-116">
            SÍ, QUIERO MIS PIES SALUDABLES — ACCESO INMEDIATO POR $14.00
          </Button>
        </motion.div>
      </div>
    </section>;
}